import {EggEntity} from "../config/EggConfig";
import {NormalBackpackI} from "../../../manager/DefineInterface";
import BackpackEventConfig, {backPackEventMap} from "../../../config/BackpackEventConfig";

const {ccclass, property} = cc._decorator;

/**
 * 鸡蛋 图鉴 item
 */
@ccclass
export default class ItemEggDrawing extends cc.Component {

    @property( cc.Sprite )
    eggSpirit : cc.Sprite = null;
    @property( cc.SpriteFrame )
    eggSpiritFrame : cc.SpriteFrame[] = [];
    @property(cc.Label)
    lbName : cc.Label = null;
    @property( cc.Label )
    lbDesc : cc.Label = null;
    @property(cc.Node)
    tickNode : cc.Node = null;

    private mEggEntity : EggEntity;
    private goodsEntity : NormalBackpackI ;

    onLoad () {}

    start () {

    }

    bindData( eggEntity : EggEntity ){
        this.mEggEntity = eggEntity;
        this.goodsEntity = backPackEventMap()[this.mEggEntity.goodsId];
        this.refreshData();
    }

    /**
     * 刷新数据
     */
    refreshData(){
        if ( this.goodsEntity ) {
            this.lbName.string = `${this.goodsEntity.name}`;
            this.lbDesc.string = `简介:${this.goodsEntity.details}`;
            this.eggSpirit.spriteFrame = this.eggSpiritFrame[ this.goodsEntity.id - 21001];
        }
    }
}
